export const initSavedSearchForm = () => {
  const savedSearchButton = document.getElementById(
    "saved-search-button",
  ) as HTMLButtonElement | null;

  if (!savedSearchButton) {
    return;
  }

  const dialog = document.getElementById("dialog-saved-search-success") as HTMLDialogElement;

  savedSearchButton.addEventListener("click", () => {
    const searchParams = document.getElementById("saved-search-params") as HTMLInputElement;
    const params = JSON.parse(searchParams.value);

    const formData = new FormData();
    formData.append("search_params", JSON.stringify(params));

    fetch("/website-api/saved-search/", {
      credentials: "same-origin",
      method: "post",
      body: formData,
    })
      .then(async (response) => {
        const data = await response.json().catch(() => null);

        if (!response.ok || !data || data.metadata.code !== 201) {
          alert(data?.metadata?.error_message ?? "Something went wrong. Please try again.");
          return;
        }

        savedSearchButton.classList.add("d-none");

        const titleElement = document.getElementById("saved-search-success-title") as HTMLElement;

        titleElement.textContent = data.data.title;
        dialog.showModal();
      })
      .catch(() => {
        alert("Something went wrong. Please try again.");
      });
  });
};
